/*
 |--------------------------------------------------------------------------
 | Table
 |
 | This module adds functionality to the Sitecore and Angular version of
 | the table component
 |--------------------------------------------------------------------------
 */

const { capitalize } = require('lodash');

class ATable {
  listeners = [];

  constructor(element) {
    this.element = element;
  }

  init = () => {
    this.rows = this.element.querySelectorAll('tr');

    this.rows.forEach((row) => {
      row.addEventListener('click', this.toggleRow);
    });
  };

  // Toggle selected state of row
  toggleRow(event) {
    const row = event.currentTarget;
    const checkbox = row.querySelector(
      ':is(td:first-child, th:first-child) input[type="checkbox"]'
    );
    const isSelectable = row.dataset.selectable === 'true';
    const targetTag = event.target.tagName.toLowerCase();

    if (
      isSelectable &&
      checkbox &&
      targetTag !== 'button' &&
      targetTag !== 'a' &&
      targetTag !== 'input' &&
      targetTag !== 'label' &&
      targetTag !== 'select'
    ) {
      checkbox.click();
    }
  }
}

// Module selector
const ATableSelector = 'table.a-table';

// Initiate module
function ATableCreateInstance(element) {
  if (!element.tableClass) {
    element.tableClass = new ATable(element);
    element.tableClass.init();
  }
}

document.querySelectorAll(`${ATableSelector}`).forEach(ATableCreateInstance);

// Create new or update Table instances on DOM mutation
const ATableObserver = new MutationObserver(function (mutations) {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((element) => {
      document
        .querySelectorAll(`${ATableSelector}`)
        .forEach(ATableCreateInstance);
    });
  });
});

ATableObserver.observe(document, {
  attributes: false,
  childList: true,
  characterData: false,
  subtree: true,
});
